module.exports = __webpack_public_path__ + "img/ts3.87020ba8.png";